<h3 mat-dialog-title>Uwaga!</h3>

<p class="alert alert-danger mt-3">
	Użytkownik o takich danych już istnieje. Zmień dane
	{{ dataSource.slotId === null ? 'zgłaszającego' : 'uczestnika' }} lub wybierz jednego z listy duplikatów:
</p>

<table mat-table [dataSource]="dataSource.ownerUsers">
	<ng-container matColumnDef="id">
		<th mat-header-cell *matHeaderCellDef>ID</th>
		<td mat-cell *matCellDef="let element">{{ element.id }}</td>
	</ng-container>

	<ng-container matColumnDef="firstName">
		<th mat-header-cell *matHeaderCellDef>Imię</th>
		<td mat-cell *matCellDef="let element">{{ element.firstName }}</td>
	</ng-container>

	<ng-container matColumnDef="lastName">
		<th mat-header-cell *matHeaderCellDef>Nazwisko</th>
		<td mat-cell *matCellDef="let element">{{ element.lastName }}</td>
	</ng-container>

	<ng-container matColumnDef="birth">
		<th mat-header-cell *matHeaderCellDef>Data urodzenia</th>
		<td mat-cell *matCellDef="let element">{{ element.birth | date: 'dd.MM.yyyy' }}</td>
	</ng-container>

	<ng-container matColumnDef="userContacts">
		<th mat-header-cell *matHeaderCellDef>Dane kontaktowe</th>
		<td mat-cell *matCellDef="let element">
			@for (item of element.userContacts; track $index) {
				Tel: {{ item.phone }}<br />
				Email: {{ item.email }}
			}
		</td>
	</ng-container>

	<ng-container matColumnDef="userAddresses">
		<th mat-header-cell *matHeaderCellDef>Adres</th>
		<td mat-cell *matCellDef="let element">
			@for (item of element.userAddresses; track $index) {
				@if (item.zipCode) {
					{{ item.zipCode }},
				}
				{{ item.city }}<br />
				{{ item.street }}
			}
		</td>
	</ng-container>

	<ng-container matColumnDef="isSelected">
		<th mat-header-cell *matHeaderCellDef></th>
		<td class="text-end" mat-cell *matCellDef="let element">
			@if (selectedUserId() === element.id) {
				<i class="fas fa-check-circle text-success"></i>
			}
		</td>
	</ng-container>

	<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
	<tr
		role="button"
		class="hover-bg"
		mat-row
		*matRowDef="let row; columns: displayedColumns"
		(click)="selectRow(row)"
	></tr>
</table>

<mat-dialog-actions class="mt-3" align="end">
	<button color="warn" mat-raised-button (click)="closeDialog()">Porzuć</button>
	<button [disabled]="!selectedUserId()" color="primary" mat-raised-button (click)="submit()">Zmień</button>
</mat-dialog-actions>
